import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button } from '@mui/material'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { VisitorRegistrationCompanyFields } from '../../../../types/Company'
import useValidationRule from '../../../../hooks/useValidationRule'
import { FlexColumn } from '../../../atoms/layout/Flex'
import Form from '../../../atoms/inputs/Form'
import FormItem from '../../../molecules/inputs/FormItem'
import TextField from '../../../atoms/inputs/TextField'
import PostalCodeField from '../../../molecules/inputs/PostalCodeField'
import RadioControl from '../../../atoms/inputs/RadioControl'
import DateControl from '../../../atoms/inputs/DateControl'
import { CompanySelectors } from '../../../../store/company/selectors'
import { CompanyActions } from '../../../../store/company'

type Props = {
  form?: VisitorRegistrationCompanyFields
}

export default function VisitorRegistrationCompanyForm(props: Props) {
  const { form: propsForm } = props
  const company = useSelector(CompanySelectors.company)
  const dispatch = useDispatch()
  const validationRule = useValidationRule()
  const form = useForm<VisitorRegistrationCompanyFields>({
    resolver: yupResolver(validationRule.visitorRegistrationCompany),
    defaultValues: propsForm ?? {
      companyName: company?.name,
      companyZipCode: company?.zipCode,
      companyAddress: company?.address,
      companyPhoneNumber: company?.phoneNumber,
      representativeName: company?.representativeName,
    },
  })
  const { errors } = form.formState

  const handleSave = useCallback(
    (fields: VisitorRegistrationCompanyFields) => {
      dispatch(CompanyActions.saveVisitorRegistrationForm({ company: fields }))
    },
    [dispatch]
  )

  return (
    <Form onSubmit={form.handleSubmit(handleSave)}>
      <FlexColumn>
        <FormItem label="事業者名" required>
          <TextField register={form.register('companyName')} error={errors.companyName?.message} />
        </FormItem>
        <FormItem label="事業者名かな" required>
          <TextField register={form.register('companyKana')} error={errors.companyKana?.message} />
        </FormItem>
        <FormItem label="郵便番号" required>
          <PostalCodeField
            getValues={form.getValues}
            name="companyZipCode"
            register={form.register('companyZipCode')}
            onSearchAddress={(address) => form.setValue('companyAddress', address)}
            error={errors.companyZipCode}
          />
        </FormItem>
        <FormItem label="住所" required>
          <TextField register={form.register('companyAddress')} error={errors.companyAddress?.message} />
        </FormItem>
        <FormItem label="電話番号" required>
          <TextField register={form.register('companyPhoneNumber')} error={errors.companyPhoneNumber?.message} />
        </FormItem>
        <FormItem label="代表者氏名" required>
          <TextField register={form.register('representativeName')} error={errors.representativeName?.message} />
        </FormItem>
        <FormItem label="代表者氏名かな" required>
          <TextField register={form.register('representativeKana')} error={errors.representativeKana?.message} />
        </FormItem>
        <FormItem label="血液型" required>
          <RadioControl
            items={[
              { value: 'A', label: 'A型' },
              { value: 'B', label: 'B型' },
              { value: 'O', label: 'O型' },
              { value: 'AB', label: 'AB型' },
            ]}
            name="representativeBloodType"
            control={form.control}
            row
            error={errors.representativeBloodType?.message}
          />
        </FormItem>
        <FormItem label="生年月日" required>
          <DateControl
            name="representativeBirthDate"
            control={form.control}
            error={errors.representativeBirthDate?.message}
          />
        </FormItem>
        <Button type="submit" variant="contained">
          保存
        </Button>
      </FlexColumn>
    </Form>
  )
}
